import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=2e4cfcff&scoped=true"
import script from "./skeleton.vue?vue&type=script&lang=js"
export * from "./skeleton.vue?vue&type=script&lang=js"
import style0 from "./skeleton.vue?vue&type=style&index=0&id=2e4cfcff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4cfcff",
  null
  
)

export default component.exports